import { Component, OnInit, OnDestroy } from '@angular/core';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';
import { DomService } from 'app/components/dom/dom.service';
import { WelcomePackService } from 'app/components/welcome-pack/welcome-pack.service';
import { UtilsService } from 'app/components/utils/utils.service';
import { File, removeExtFromUrlFile } from 'app/models/file.model';

@Component({
  selector: 'app-exhibitor-backoffice-util-info',
  templateUrl: './exhibitor-backoffice-util-info.component.html',
  styleUrls: ['./exhibitor-backoffice-util-info.component.css']
})
export class ExhibitorBackofficeUtilInfoComponent implements OnInit {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';

  welcomePackTranslations: Array<any> = [];
  welcomeBoxes: Array<any> = [];
  welcomeFiles: Array<any> = [];

  constructor(public catalogueService: CatalogueService, private domService: DomService, private welcomePackService: WelcomePackService,
  public utilsService: UtilsService) {
  }


  getCatalogueWelcomePack(getCatalogueWelcomePackIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.welcomePackService.getCatalogueWelcomePack(getCatalogueWelcomePackIn)
      .subscribe((data: object) => {
        this.getCatalogueWelcomePackOk(data);
      },
        error => {
          this.getCatalogueWelcomePackError(error);
        });

  }

  getCatalogueWelcomePackOk(data) {

    this.loader.count--;
    this.welcomePackTranslations = data.translations;

    let getWelcomeBoxesIn = {
      welcomePackId: data.id
    }

    this.getWelcomeBoxes(getWelcomeBoxesIn);

    let getWelcomeFilesIn = {
      welcomePackId: data.id
    }

    this.getWelcomeFiles(getWelcomeFilesIn);

  }

  getCatalogueWelcomePackError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getWelcomeBoxes(getWelcomeBoxesIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.welcomePackService.getWelcomeBoxes(getWelcomeBoxesIn)
      .subscribe((data: object) => {
        this.getWelcomeBoxesOk(data);
      },
        error => {
          this.getWelcomeBoxesError(error);
        });

  }

  getWelcomeBoxesOk(data) {

    this.loader.count--;
    this.welcomeBoxes = data._embedded.welcomeBoxes;

  }

  getWelcomeBoxesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getWelcomeFiles(getWelcomeFilesIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.welcomePackService.getWelcomeFiles(getWelcomeFilesIn)
      .subscribe((data: object) => {
        this.getWelcomeFilesOk(data);
      },
        error => {
          this.getWelcomeFilesError(error);
        });

  }

  getWelcomeFilesOk(data) {

    this.loader.count--;
    this.welcomeFiles = data._embedded.welcomeFiles;

  }

  getWelcomeFilesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getUrl(translations) {
    let url = this.utilsService._api(translations, 'link');
    return (url.toLowerCase() !== "translation not found") ? url : '';
  }

  goTo(translations) {

    let link = this.utilsService._api(translations, 'link');
    let url = (link.toLowerCase() !== "translation not found") ? link : '';

    if (url) {
      window.open(url, '_blank');
    }

  }


  removeExtFromUrlFile(url: string): string {
    return removeExtFromUrlFile(url);
  }

  ngOnInit() {

    this.domService.addClassToBody('bg-gray');

    let getCatalogueWelcomePackIn = {
      catalogueId: this.catalogueService.getProperty('id')
    }

    this.getCatalogueWelcomePack(getCatalogueWelcomePackIn);

  }

  ngOnDestroy() {
    this.domService.removeClassFromBody('bg-gray');
  }

}
